module.exports = __webpack_public_path__ + "img/DE00034.86785524.png";